<template>
  <div style="height: 100%">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else >
      <v-card flat v-if="currentBusiness">

        <PrintViewBar v-if="Invoice" :showEmailBtn="showEmailBtn" :id="Invoice.id" type="invoice"
          :title="`Invoice # ${this.Invoice.localId}`" :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name" :email="printEmail" :obj="Invoice.Donor"
          :text="`${currentBusiness.name} Invoice click here to view`" />


        <v-container fluid>
          <v-card-text >
            <div v-if="!$vuetify.breakpoint.xsOnly">
              <img class="paidImg" v-if="Invoice.due === 0" width="300" src="../../../assets/paidStamp.png" />
              <img class="paidImg" v-if="Invoice.deletedAt" width="300"
                src="../../../assets/deletedStamp-removebg-preview.png" />
            </div>

            <v-layout row fill-height>
              <v-flex class="text-left text-capitalize">
                <div class=" headline font-weight-bold"
                  v-if="currentBusiness && currentBusiness.metadata && currentBusiness.metadata.dbaName">
                  {{ currentBusiness.metadata.dbaName }}
                </div>
                <div class=" headline font-weight-bold" v-else>
                  {{ currentBusiness.name }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase">{{ currentBusiness.state }}
                  </span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.email }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.website }}
                </div>

                <div :class="{ 'display-3': !$vuetify.breakpoint.xsOnly }"
                  class="mt-2 text-h3 font-weight-black blue--text">
                  RECEIPT
                </div>
                <div class="font-weight-regular">
                  <div class="font-weight-regular">DONOR INFORMATION</div>
                  <div class="font-weight-bold">
                    <span v-if="Invoice.Donor">{{ Invoice.Donor.name }}</span>
                  </div>
                  <div>
                    <span v-if="Invoice.Donor.phoneNumber">{{ Invoice.Donor.phoneNumber }}</span>
                  </div>
                  <div>
                    <span v-if="Invoice.Donor">{{ Invoice.Donor.address }}</span>
                  </div>
                  <div v-if="Invoice.Donor && Invoice.Donor.city">
                    {{ Invoice.Donor.city }},<span class="text-uppercase">{{ Invoice.Donor.state }}
                    </span>
                    {{ Invoice.Donor.zip }}
                  </div>
                  <div v-if="Invoice.Customer && Invoice.Customer.city">
                    {{ Invoice.Customer.city }},<span class="text-uppercase">{{ Invoice.Customer.state }}
                    </span>
                    {{ Invoice.Customer.zip }}
                  </div>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-right" >
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img v-if="currentBusiness.imageUrl" height="120" class="logo mb-3" :src="currentBusiness.imageUrl"
                    alt="" />
                </div>
                <div v-if="!$vuetify.breakpoint.xsOnly" class="barcode mt-2">
                  *{{ Invoice.localId }}*
                </div>
                <div class="font-weight-regular">
                  <v-row>
                    <v-col class="pb-0">INVOICE #</v-col>
                    <v-col class="pb-0">{{ Invoice.localId }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">DATE: </v-col>
                    <v-col class="py-0">{{ Invoice.date | moment("MM/DD/YYYY") }}</v-col>
                  </v-row>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-text >
            <v-data-table class="mt-5" dense :headers="headers"
              sort-by="name" :itemsPerPage="Invoice.InvoiceDetails.length" hide-default-footer
              :items="Invoice.InvoiceDetails">
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left"><span>{{ item.qty }}x </span>{{ item.name }} <span class="font-weight-bold"
                      v-if="item.Student && item.Student.fullName">({{ item.Student.fullName }})</span></td>
                  <!-- <td class="text-center">{{ item.qty }}</td> -->
                  <!-- <td class="text-right">
                                                    <span>{{ item.price | currency }}
                                                      <span v-if="showCost">/{{ item.cost | currency }}</span>
                                                    </span>
                                                  </td> -->
                  <td class="text-right">
                    {{ (item.price * item.qty) | currency }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-text class="pr-4">
            <v-divider></v-divider>
            <v-row>

              <v-col sm="6" md="4" offset-md="8" offset-sm="6">
                <v-layout class="title mr-2">
                  <v-flex>
                    <div class="font-weight-medium text-right">TOTAL AMOUNT</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ Invoice.total | currency }}
                    </div>
                  </v-flex>
                </v-layout>


              </v-col>
            </v-row>
            
            <div v-if="currentBusiness && currentBusiness.metadata && currentBusiness.metadata.taxExam"
              class="font-weight-medium mt-3 ">
              <v-divider></v-divider>
              <div v-if="Invoice && Invoice.metadata && Invoice.metadata.paymentCycle">
                Cycle: {{ Invoice.metadata.paymentCycle }}
              </div>
              <div v-if="Invoice && Invoice.metadata && Invoice.metadata.paymentType">
                Payment Type: {{ Invoice.metadata.paymentType }}
              </div>
              <div class="text-center mt-5">
                {{ currentBusiness.metadata.taxExam }}
              </div>
            </div>
            <v-col class="mt-4" align="right">
              Power By: <span>taleem.app</span>
              <!-- <img width="100" src="@/assets/images/poweredbylogo.png" /> -->
            </v-col>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";

import invoiceService from "../service";
import Hashids from "hashids";
import { mapGetters, mapActions } from "vuex";
const hashids = new Hashids();

export default {
  data() {
    return {
      pdf: null,
      doc: {
        info: {
          title: 'Invoice Preview',
        },
        content: [],
        styles: {
          locationInfo: {
            alignment: 'center',
            fontSize: 8,
          },
          heading: {
            alignment: 'center',
            fontSize: 10,
          },
          policy: {
            alignment: 'justify',
            fontSize: 6,
          },
          topDetails: {
            margin: [0, 0],
            fontSize: 8,
          },
          invoiceDetails: {
            margin: [0, 2],
            fontSize: 8,
          },
          totals: {
            margin: [0, 0],
            fontSize: 8,
          },
        },
      },
      showCost: false,
      showEmailBtn: true,
      isLoading: true,
      Invoice: {
        InvoiceDetails: [],
      },
      headers: [
        {
          text: "DETAIL",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        // {
        //   text: "QTY",
        //   align: "center",
        //   value: "qty",
        //   sortable: false,
        // },
        // {
        //   text: "RATE",
        //   align: "right",
        //   value: "rate",
        //   sortable: false,
        // },
        {
          text: "AMOUNT",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    printEmail() {
      let email = null
      if (this.Invoice.Donor && this.Invoice.Donor.email) {
        email = this.Invoice.Donor.email
      }
      if (this.Invoice.Donor && this.Invoice.Donor.email) {
        email = this.Invoice.Donor.email
      }

      return email
    }
  },
  created() {
    if (this.$route.meta.public) {
      this.loadPublicData();
    } else {
      this.loadData();
      if (!this.currentBusiness) this.initUser();
    }
  },
  components: { PrintViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      return invoiceService
        .publicGetById(id, { invoice: true, key: key })
        .then((response) => {
          console.log("response invoice", response);
          this.initBusiness(response.business);
          this.$Progress.finish();
          this.Invoice = response.data;
          document.title = `${this.currentBusiness.name} - Invoice # ${this.Invoice.localId}`;
          if (this.Invoice.InvoiceDetails) {
            this.Invoice.InvoiceDetails.map((row) => {
              this.totalQty += Math.abs(parseInt(row.totalQty));
            });
          }
          this.isLoading = false;
        });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      return invoiceService.getById(id, { invoice: true }).then((response) => {
        console.log("response", response);
        this.Invoice = response.data;
        if (this.Invoice.Donor && this.Invoice.Donor.email) {
          this.showEmailBtn = true;
        }
        if (this.Invoice.InvoiceDetails) {
          this.Invoice.InvoiceDetails.map((row) => {
            this.totalQty += Math.abs(parseInt(row.totalQty));
          });
        }

        this.isLoading = false;
      });
    },
  },
};
</script>




<style scoped>

@media print {

  container {
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }

  
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
